import { SuspensionActionContext } from './types'

export const SUSPENSION_ACTION_CONTEXT_TO_EXPLANATION: Record<
  SuspensionActionContext,
  string | null
> = {
  [SuspensionActionContext.SessionRemoval]:
    'You were recently removed from a Zoom session by the session host. ' +
    'While this could be due to a technical issue, this triggers a temporary flag on your account.',
  [SuspensionActionContext.AutomaticSuspension]:
    'Your account was automatically flagged by the Schoolhouse system.',
  [SuspensionActionContext.LearnerNoShows]:
    'Your account was frozen for repeatedly missing required attendance sessions.',
  [SuspensionActionContext.CommunitySuspension]: 'Potential violation of community guidelines.',
  [SuspensionActionContext.OnboardingRejection]: 'We need more information from you.',
  [SuspensionActionContext.UserAdminPage]: 'Potential violation of community guidelines.',
}

export const ERROR_USER_PHONE_NUMBER_IN_USE = 'This phone number is already in use.'

export const USER_PHONE_VERIFICATION_CODE_LENGTH = 6

export const USERNAME_CHANGE_THRESHOLD_DAYS = 60
export const USERNAME_MAX_LENGTH = 25
export const USERNAME_MIN_LENGTH = 3

export const TUTORING_MINUTES_TOOLTIP_EXPLANATION =
  'As of May 2024, this number only includes the time a learner is in a Zoom session with you.'
